<div class="layout-main">
  <div class="container-fluid">
    <div class="page-header pb-2 mb-3 border-bottom">
      <h3><b>Encryption keys</b></h3>
      <button (click)="downloadAvailableEncryptionKeys()" [disabled]="!encryptionKeysInfo?.length" class="download-btn"
              id="download_past_file_with_multi_date_button" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>
        Download available keys
      </button>
    </div>
    <p-table (sortFunction)="tableService.customSort($event)" [columns]="columns" [customSort]="true"
             [loading]="loading" [value]="encryptionKeysInfo" id="prod_encryption_keys_logs">
      <ng-template pTemplate="loadingicon">
        <p-progressSpinner [style]="{width: '48px', height: '48px'}" animationDuration="1.2s"
                           strokeWidth="4"></p-progressSpinner>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumnDisabled]="col.sortDisabled" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field" ariaLabel="Activate to sort"
                        ariaLabelAsc="Activate to sort in ascending order"
                        ariaLabelDesc="Activate to sort in descending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template let-key pTemplate="body">
        <tr>
          <td class="record-cell">{{ key.pop }}</td>
          <td>{{ key.channel }}</td>
          <td>{{ key.products }}</td>
          <td>
            <span [class.action-badge--protected]="key.protected" class="action-badge">{{ key.protected ? 'Yes' : 'No' }}</span>
          </td>
          <td class="when-cell">{{ getWeek1(key) }}</td>
          <td class="when-cell">{{ getWeek2(key) }}</td>
          <td class="when-cell">{{ getWeek3(key) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns?.length">
            <div *ngIf="loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
              <div class="empty-state-title">The encryption keys could not be loaded</div>
              <div class="empty-state-subtitle">Please try again later.</div>
            </div>
            <div *ngIf="!loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-search"></i>
              <div class="empty-state-title">No encryption key available</div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
